import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { distinctUntilChanged, map, take, takeUntil } from 'rxjs/operators';
import { LcaService } from 'src/app/services/lca.service';
import { UploadDocumentService } from '../../../services/upload-document.service';
import { LCAAddNew } from 'src/app/data/models/lcaaddnew.model';
import { environment } from '../../../../environments/environment';
import { FileUploadLibraryService } from 'file-upload-library';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import { MarkCleanFormAction, MarkDirtyFormAction } from '../../../app-state/actions/dirty-form.actions';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { version } from 'process';
import { HelpVideoOverlayComponent } from '../../../modules/shared/help-video-overlay/help-video-overlay.component';
import * as errorUtils from '../../../modules/utility/global-utils';
import { acceptedFileTypes } from 'app-models';
import { CustomErrorToastComponent } from 'custom-error-toast';
@Component({
    selector: 'app-manage-lca',
    templateUrl: './manage-lca.component.html',
    styleUrls: ['./manage-lca.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ManageLcaComponent implements OnInit {

    @ViewChild('closebutton') closebutton;

    lca = new LCAAddNew({})
    isDuplicateLCA: boolean = false;
    showTheViewModeSection: boolean = false;
    originPage: string;
    originUrl: string;
    // lca:any;
    downloadedCond: boolean;
    osInstalled: any;
    CopyToClipboard: any = 'Copy To Clipboard';
    eFileLCa: string = '';
    resetEfile: boolean = false;
    enableNextStepperButton: boolean = false;
    lcaApprovedDate: Date;
    maxDateValue = new Date();
    configurations = {
        inputMultipleFlag: false,
        fileType: acceptedFileTypes,
        isFileListRequired: true,
        categoryName: 'LCADOC',
        entityId: 0,
        fileCategory: 'LCA',
        listUploadedFiles: [],
        documentTypeRequired: true,
        docummentTypeCode: 'LCADOC',
        useCase: 'company',
        useCaseId: parseInt(sessionStorage.getItem('companyId')),
        useEntityId: false
    };
    workForceConfigurations = {
        inputMultipleFlag: false,
        fileType: acceptedFileTypes,
        isFileListRequired: true,
        categoryName: 'LCAWRKFRCNOTF',
        entityId: 0,
        fileCategory: 'LCA',
        listUploadedFiles: [],
        documentTypeRequired: false,
        docummentTypeCode: 'LCAWRKFRCNOTF',
        useCase: 'company',
        useCaseId: parseInt(sessionStorage.getItem('companyId')),
        useEntityId: false,
        isUploadEnabled: true
    };
    envPath: string;
    destroy$ = new Subject();
    formChangesSubscription: any;
    lcaForm: FormGroup;
    launchTracker: FormGroup;
    lcaPreviewForm: FormGroup;
    employerInfo: any;
    employerPointOfContactInfo: any;
    attorneyOrAgentInfo: any;
    lcaAdlEmplStatH1BOnly: any;
    lcaPreparer: any;
    noticeOfObligations: any;
    EmpLCS: any;
    publicDiscloseInfo: any;

    editLcaData: any;
    previewEditLcaData: any;
    userEfileInfo: any;
    lcaEditID = null;
    // showEfiling: boolean = true;
    @ViewChild(HelpVideoOverlayComponent, { static: false }) helpVideoComponent: HelpVideoOverlayComponent;
    // isWorkforceNotified:boolean = true;
    // isWorkForceFileUploaded:boolean = false;
    //  workforceNotifiedDate:any;
    isSaveAsDraftDisabled: boolean = true;
    formChangeSubscription: Subscription;
    ocrLCAUploadedFilesData: any;
    lcaDocumentFileUploadConfigurations = {
        inputMultipleFlag: true,
        fileType: acceptedFileTypes,
        isFileListRequired: true,
        categoryName: 'OCRDOCTYPE',
        entityId: 1,
        fileCategory: '',
        listUploadedFiles: [],
        documentTypeRequired: true,
        docummentTypeCode: 'OCRDOCTYPE',
        useCase: 'company',
        useCaseId: parseInt(sessionStorage.getItem('companyId')),
        useEntityId: false,
        isDeleteEnabled: true,
        isUploadEnabled: true,
        isDownloadEnabled: false,
        familyId: null,
        family: false
    };
    extractedLCADetails: any = {};

    showPopup: boolean = false;
    filedLcaType = 'automatic';

    constructor(private router: Router,
        private httpClient: HttpClient, private route: ActivatedRoute, private uploadDocumentService: UploadDocumentService, private toastr: ToastrService, private lcaService: LcaService, public uploadService: FileUploadLibraryService, private fb: FormBuilder, private dialog: MatDialog, protected store: Store<any>) {
        const navState = this.router.getCurrentNavigation();
        this.originUrl = (navState.extras && navState.extras.state && navState.extras.state.redirectUrl) ? navState.extras.state.redirectUrl : '';
        this.originPage = (navState.extras && navState.extras.state && navState.extras.state.redirectPage) ? navState.extras.state.redirectPage : '';
        this.originUrl = this.originUrl == '' ? '../lca' : this.originUrl; //fall back to list page 
        if (sessionStorage.getItem('originPage') && sessionStorage.getItem('originUrl')) {
            this.originPage = sessionStorage.getItem('originPage');
            this.originUrl = sessionStorage.getItem('originUrl');
        }
    }

    ngOnInit() {
        this.createlaunchTracker();
        this.resetEfile = false;
        this.envPath = environment.docs;
        this.getUpolodedFiles();
        this.getWorkForceUpolodedFiles();
        if (sessionStorage.getItem('lcaId')) {
            this.showTheViewModeSection = true;

        } else {
            this.showTheViewModeSection = false;
        }

        this.isDuplicateLCA = sessionStorage.getItem("isDuplicateLCA") === 'true';

        if (sessionStorage.getItem("lcaId") !== null) {
            this.createLcaForm();
            this.lcaService.getEFileDetails(parseInt(sessionStorage.getItem("lcaId"))).pipe(takeUntil(this.destroy$)).subscribe((response) => {
                console.log(response, 1234);
                if (response) {
                    if (response.lcaApplication.status.code == "LCAEXTFIL") {
                        this.eFileLCa = 'filedLCA';
                    } else if (response.lcaApplication.status.code == "LCACERT") {
                        this.eFileLCa = 'certifiedLCA';
                    } else {
                        this.eFileLCa = 'lcaEFile';
                    }
                    this.editLcaData = response;
                    localStorage.setItem('userEfileInfo', JSON.stringify(response));
                    this.lcaForm.get('lcaPreparer').patchValue({
                        firstName: response.lcaPreparer.firstName,
                        middleName: response.lcaPreparer.middleName,
                        lastName: response.lcaPreparer.lastName,
                        firmName: response.lcaPreparer.firmName,
                        emailId: response.lcaPreparer.email.mailId,
                        personType: response.lcaPreparer.personType.code,
                    });
                    this.lcaForm.patchValue({ comment: response.lcaApplication.comment });



                    localStorage.setItem('userEfileInfo', JSON.stringify(response));

                    this.lcaEditID = sessionStorage.getItem('lcaId');


                    this.getUserDetails();
                    this.launchTracker.patchValue({
                        lcaId: this.lcaEditID,

                    })
                }
            });
        } else {
            this.eFileLCa = 'lcaEFile';
        }

        if (this.originUrl !== '../lca') {
            this.createNew();
        }

        if (sessionStorage.getItem("isCertifiesId") === "LCAUNASSI" || sessionStorage.getItem("isCertifiesId") === "LCAASSIGN" || sessionStorage.getItem("isCertifiesId") === "LCACERT" || (this.originUrl !== '../lca' && this.originUrl !== 'petitioner-landing/immigration-wizard/upload/soc-code')) {
            // this.showEfiling = false;
            // this.eFileLCa = '';
            this.createLcaForm();
        }
        else {
            this.createLcaForm();
        }
    }

    createNew() {
        sessionStorage.removeItem('lcaId');
        this.router.navigate(['../add-new'],
            { relativeTo: this.route, state: { redirectUrl: '../lca', redirectPage: 'Back to Lca List' } });
    }

    ngAfterViewInit() {
        this.formChangesSubscription = this.lcaForm.valueChanges.pipe(
            map(() => this.lcaForm.dirty && this.lcaForm.enabled),
            distinctUntilChanged(),
            takeUntil(this.destroy$)
        ).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            } else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
        this.formChangeSubscription = this.lcaForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(formValues => {
            this.isSaveAsDraftDisabled = !Object.values(formValues).some((val) => !!val || val === 0);
        });
        this.helpVideoComponent.setTabValues(
            'right',
            'How to E-file LCA',
            'Part 1 LCA E-filing through Imagility',
            'Part 1 LCA E-filing through Imagility',
            'right',
            'Part 2 LCA E-filing through Imagility',
            'Part 2 LCA E-filing through Imagility'
        );
    }

    getUpolodedFiles() {
        this.uploadDocumentService.genericGetUploadDocument(this.configurations.useCase, this.configurations.useCaseId, this.configurations.categoryName, this.configurations.entityId, this.configurations.useEntityId).pipe(take(1)).subscribe((response) => {
            if (response['status'] === 200) {
                this.configurations.listUploadedFiles = response['data'];
                this.configurations = Object.assign({}, this.configurations);
            }
            else {
                this.configurations.listUploadedFiles = [];
                this.configurations = Object.assign({}, this.configurations);
            }
        });
    }

    getWorkForceUpolodedFiles() {
        this.uploadDocumentService.genericGetUploadDocument(this.workForceConfigurations.useCase, this.workForceConfigurations.useCaseId, this.workForceConfigurations.categoryName, this.workForceConfigurations.entityId, this.workForceConfigurations.useEntityId).pipe(take(1)).subscribe((response) => {
            if (response['status'] === 200) {
                this.workForceConfigurations.listUploadedFiles = response['data'];
                this.workForceConfigurations = Object.assign({}, this.workForceConfigurations);
            }
            else {
                this.workForceConfigurations.listUploadedFiles = [];
                this.workForceConfigurations = Object.assign({}, this.workForceConfigurations);
            }

            // this.workForceConfigurations.entityId = this.workForceConfigurations.listUploadedFiles.length > 0 ? 0 : this.lcaId;
            // this.workForceConfigurations.isUploadEnabled =  this.workForceConfigurations.listUploadedFiles.length > 0 ? false : true; 
        });
    }

    backToOriginPage() {
        if (this.originUrl?.includes('immigration-wizard')) {
            this.router.navigate([`${this.originUrl}`]);
        } else {
            this.router.navigate([`${this.originUrl}`], { relativeTo: this.route });
        }
    }

    lcaChangeHandler(lca) {
        if (lca) {
            this.lca = lca;

            // this.lcaId = parseInt(lca.id);
            // this.lcalcaAppliedDate = new Date()
            this.lcaApprovedDate = lca.lcaAppliedDate ? new Date(lca.lcaAppliedDate) : null;
            this.configurations.entityId = parseInt(lca.id);
            this.configurations.useCaseId = parseInt(lca.companyId);
            this.configurations = Object.assign({}, this.configurations);
            this.workForceConfigurations.entityId = parseInt(lca.id);
            this.workForceConfigurations.useCaseId = parseInt(lca.companyId);
            this.workForceConfigurations = Object.assign({}, this.workForceConfigurations);
            this.enableNextStepperButton = true;
            this.getUpolodedFiles();
            this.getWorkForceUpolodedFiles();
        }
    }

    editChangeHandler(val) {
        if (val) {
            this.showTheViewModeSection = false;
        }
    }

    saveLcaWorkNotify() {
        let payload: any = {};
        payload = {
            ...this.lca,
            employmentStartDate: this.lca.employmentStartDate ? moment(this.lca.employmentStartDate).format('YYYY-MM-DD') : '',
            employmentEndDate: this.lca.employmentEndDate ? moment(this.lca.employmentEndDate).format('YYYY-MM-DD') : '',
            lcaAppliedDate: this.lca.lcaAppliedDate ? moment(this.lca.lcaAppliedDate).format('YYYY-MM-DD') : '',
            certifiedDate: this.lca.certifiedDate ? moment(this.lca.certifiedDate).format('YYYY-MM-DD') : ''
            // isWorkforceNotified:this.isWorkforceNotified,
            //this.lca.workforceNotifiedDate=this.workforceNotifiedDate ? moment(this.workforceNotifiedDate).toISOString():''

        }
        payload.workforceNotifiedDate = payload.workforceNotifiedDate ? moment(payload.workforceNotifiedDate).format('YYYY-MM-DD') : '';

        if (this.eFileLCa == 'filedLCA') {
            payload.lcaFiledType = 'Ext-Filed';
        } else if (this.eFileLCa == 'certifiedLCA') {
            payload.lcaFiledType = 'Ext-Certified';
        } else {
            payload.lcaFiledType = 'E-Filed';
        }
        this.lcaService.createLCA(payload).subscribe(response => {
            if (response['status'] === 200) {
                this.toastr.success(response['message'], 'Success');
                this.backToOriginPage();
            } else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response['message']);
            }
        });

    }

    downloadFile(file) {
        this.uploadService.downloadDocuments(environment.docs + file.substring(22), file.substring(22));
    }

    createLcaForm() {

        this.lcaForm = this.fb.group({
            lcaEFileApplication: this.fb.group({
                visaType: ['', Validators.required],
                jobTitle: ['', Validators.required],
                socCode: ['', Validators.required],
                socTitle: ['', Validators.required],
                isFullTime: [, Validators.required],
                employmentEndDate: ['', Validators.required],
                employmentStartDate: ['', Validators.required],
                totalCount: [, Validators.required],
                newEmploymentCount: [0, Validators.required],
                continueApprovedCount: [0, Validators.required],
                changeApproveCount: [0, Validators.required],
                concurrentEmploymentCount: [0, Validators.required],
                employerChangeCount: [0, Validators.required],
                amendedPetitionCount: [0, Validators.required],
            }),

            userInfoForm: this.fb.group({
                companyName: ['', Validators.required],
                legalBusinessName: ['', [Validators.required]],
                hasTradeNameorDBA: ['', [Validators.required]],
                tradeNameOrDBA: ['', [Validators.required]],
                addressLine1: ['', Validators.required],
                id: [''],
                addressLine2: [''],
                country: ['', Validators.required],
                state: ['', Validators.required],
                city: ['', [Validators.required]],
                postalCode: ['', Validators.required],
                stateProvinceName: [''],
                extension: [''],
                telephone: ['', Validators.required],
                naicsCode: [''],
                companyNaicsCode: [''],
                companyNaicsTitle: [''],
                feiNumber: ['', Validators.required],
                isUserEdit: ['']
            }),

            employerContactInfoForm: this.fb.group({
                contactPerson: ['', Validators.required],
                firstName: ['', [Validators.required]],
                middleName: [''],
                lastName: ['', [Validators.required, Validators.minLength(2)]],
                jobTitle: ['', [Validators.required]],
                addressLine1: ['', Validators.required],
                addressLine2: [''],
                id: [''],
                employeeId: [''],
                companyId: [''],
                country: ['', Validators.required],
                state: ['', Validators.required],
                city: ['', [Validators.required]],
                postalCode: ['', Validators.required],
                stateProvinceName: [''],
                extension: ['', [Validators.pattern('^[0-9 -]+$')]],
                phoneNumber: ['', Validators.required],
                emailId: ['', [Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')]],
            }),
            attorneyInfoForm: this.fb.group({
                enableAttorney: [''],
                firmName: [''],
                attorneyName: [''],
                agentFirstName: [''],
                agentMiddleName: [''],
                agentLastName: [''],
                addressLine1: [''],
                addressLine2: [''],
                id: [''],
                country: [''],
                state: [''],
                city: [''],
                postalCode: [''],
                stateProvinceName: [''],
                extension: ['', [Validators.pattern('^[0-9 -]+$')]],
                telephone: [''],
                emailId: ['', [Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')]],
                LawFirmName: [''],
                firmFEIN: [],
                attorneyStateBarNo: [],
                attorneyStateOfHighestCourt: [],
                attorneyNameOfHighestStartCourt: []
            }),
            EmpLCS: this.fb.group({
                cbEmp: [false, Validators.requiredTrue]
            }),

            employmentWageForm: this.fb.group({
                employement: this.fb.array([])
            }),

            noticeOfObligations: this.fb.group({
                authorisePerson: [''],
                companyId: [],
                employeeId: [],
                firstName: ['', Validators.required],
                middleName: [''],
                lastName: ['', Validators.required],
                cb: [false, Validators.requiredTrue],
                designatedTitle: ['', Validators.required],
                personType: "OBLIGATOR"
            }),
            lcaAdlEmplStatH1BOnly: this.fb.group({
                isEmprH1bDependent: [, Validators.required],
                isEmprWillfulViolator: [, Validators.required],
                isEmprForExmptH1bWrkr: [, Validators.required],
                isApndxInclWrkrExmptOnHiDegr: ['', Validators.required],
                statBasisForExmptId: ['', Validators.required]
            }),
            publicDiscloseInfo: this.fb.group({
                publicDisclInfoId: ['', Validators.required]
            }),
            lcaPreparer: this.fb.group({
                firstName: [''],
                middleName: [''],
                lastName: [''],
                firmName: [''],
                emailId: ['', [Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')]],
                personType: 'PREPARER'
            }),
            comment: ['']
        })

    }

    onClickSaveLcaForm(isDraft: boolean = false) {
        //console.warn('lcaForm', this.lcaForm);   
        if (this.lcaForm.valid || isDraft) {
            let totalCount = this.lcaForm.value.lcaEFileApplication.totalCount;
            let newEmploymentCount = this.lcaForm.value.lcaEFileApplication.newEmploymentCount;
            let continueApprovedCount = this.lcaForm.value.lcaEFileApplication.continueApprovedCount;
            let changeApproveCount = this.lcaForm.value.lcaEFileApplication.changeApproveCount;
            let concurrentEmploymentCount = this.lcaForm.value.lcaEFileApplication.concurrentEmploymentCount;
            let employerChangeCount = this.lcaForm.value.lcaEFileApplication.employerChangeCount;
            let amendedPetitionCount = this.lcaForm.value.lcaEFileApplication.amendedPetitionCount;
            let sumOfOtherCount = newEmploymentCount + continueApprovedCount + changeApproveCount + concurrentEmploymentCount
                + employerChangeCount + amendedPetitionCount;

            if (sumOfOtherCount != totalCount && !isDraft) {
                CustomErrorToastComponent.showErrorToast(this.toastr, 'Total Count does not match');
                return;
            }
        }

        if (this.lcaForm.valid || isDraft) {
            // API CALL FOR SAVE API
            this.lcaService.createEFileLCA({ isSaveAsDraft: isDraft, ...this.mappingFormFields() }).pipe(takeUntil(this.destroy$)).subscribe((response) => {

                if (response && response['status'] === 200) {
                    if (response['data']) {
                        this.lcaEditID = response['data'];
                        //IM-21845 -> in case if user save LCA as draft and refreshesh the page, as of now we are not maintaining the lcaId in session after save.
                        sessionStorage.setItem("lcaId", response['data']);
                        sessionStorage.setItem("savedLcaId", response['data']);
                        if (!sessionStorage.getItem("isCertifiesId")) {
                            this.lcaService.getEFileDetails(this.lcaEditID).pipe(takeUntil(this.destroy$)).subscribe((res) => {
                                sessionStorage.setItem("isCertifiesId", res?.lcaApplication?.status?.code);
                            });
                        }
                        this.getUserDetails();
                        this.launchTracker.patchValue({
                            lcaId: this.lcaEditID
                        });
                        this.store.dispatch(new MarkCleanFormAction({
                            dirty: false
                        }));
                    }
                    this.toastr.success(response['message'], 'Success');
                    //this.lcaForm.reset()
                    //this.router.navigate([`${this.originUrl}`], { relativeTo: this.route });
                }
            });
        }
    }

    scrollToTop(event) {
        if (event) {
            window.scrollBy({
                top: -750,
                behavior: "smooth",
            });
        }
    }

    mappingFormFields() {
        const placeOfEmployments: any = [];
        // placeOfEmployments mapping
        this.lcaForm.value.employmentWageForm.employement.map((item, index) => {
            if (item) {
                const tempData: any = {
                    addressDTO: {
                        addressLine1: item.addressLine1,
                        addressLine2: item.addressLine2,
                        city: item.city,
                        // countryCode: item.country, 
                        addressTypeCode: "WORK",
                        county: item.county,
                        id: null,
                        postalCode: item.postalCode,
                        stateProvinceCode: item.state
                    },
                    frmattedPrevailingWage: "",
                    id: null,
                    lcaCodeId: null,
                    noOfWorkers: parseInt(item.noOfWorkers),
                    secEntBusName: item.secEntBusName,
                    prvWageTypeCode: item.prvWageTypeCode,
                    prvlWageRate: parseInt(item.prvlWageRate),
                    prvlWageSourceId: item.prvlWageSourceId,
                    sequenceNo: index + 1,
                    wageRangeFrom: parseInt(item.wageRangeFrom),
                    wageRangeTo: parseInt(item.wageRangeTo),
                    wageRangeTypeCode: item.wageRangeTypeCode
                };

                if (item.prvlWageSourceId == "PWDLABDEPT") {
                    tempData.pwdTrackNumber = item.pwdTrackNumber;
                }
                if (item.prvlWageSourceId == "PWDOESPROG") {
                    tempData.pwdOesSourceLevelId = item.pwdOesSourceLevelId;
                    // No longer needed as number type, as the format changed now it'll be string. Hence removing parseInte()
                    tempData.pwdOesSourceYear = item.pwdOesSourceYear;
                    tempData.countyAreaName = item?.countyAreaName;
                }
                if (item.prvlWageSourceId == "PWDOTHERLEGTSRC") {
                    tempData.pwdOtherSourceId = item.pwdOtherSourceId;
                    tempData.otherPwdSurveyName = item.otherPwdSurveyName;
                    tempData.otherPwdSurveyPublshr = item.otherPwdSurveyPublshr;
                    tempData.pwdOtherSourceYear = item.pwdOtherSourceYear;
                }

                placeOfEmployments.push(tempData);
            }
        });

        // employerInfo mapping
        let isCompanyUpdateStatus;
        if ((this.lcaForm.value.userInfoForm.isUserEdit.hasTradeNameorDBA === this.lcaForm.value.userInfoForm.hasTradeNameorDBA) && (this.lcaForm.value.userInfoForm.isUserEdit.tradeNameOrDBA === this.lcaForm.value.userInfoForm.tradeNameOrDBA)) {
            isCompanyUpdateStatus = false;
        } else {
            isCompanyUpdateStatus = true;
        }

        if (this.lcaEditID) {
            if ((this.lcaForm.value.userInfoForm.isUserEdit.hasTradeNameorDBA === this.lcaForm.value.userInfoForm.hasTradeNameorDBA) && (this.lcaForm.value.userInfoForm.isUserEdit.tradeNameOrDBA === this.lcaForm.value.userInfoForm.tradeNameOrDBA)) {
                isCompanyUpdateStatus = false;
            } else {
                isCompanyUpdateStatus = true;
            }
        } else {
            if (this.lcaForm.value.userInfoForm.tradeNameOrDBA) {
                isCompanyUpdateStatus = true;
            } else {
                isCompanyUpdateStatus = false;
            }
        }

        this.employerInfo = {
            companyId: this.lcaForm.value.userInfoForm.companyName,
            isCompanyUpdate: isCompanyUpdateStatus,
            hasTradeNameorDBA: this.lcaForm.value.userInfoForm.hasTradeNameorDBA,
            legalBusinessName: this.lcaForm.value.userInfoForm.legalBusinessName,
            tradeNameOrDBA: this.lcaForm.value.userInfoForm.tradeNameOrDBA,
            phoneNumber: this.lcaForm.value.userInfoForm.telephone,
            extension: this.lcaForm.value.userInfoForm.extension,
            naicsCode: this.lcaForm.value.userInfoForm.naicsCode,
            feiNumber: this.lcaForm.value.userInfoForm.feiNumber,
            address: {
                addressLine1: this.lcaForm.value.userInfoForm.addressLine1,
                addressLine2: this.lcaForm.value.userInfoForm.addressLine2,
                city: this.lcaForm.value.userInfoForm.city,
                countryCode: this.lcaForm.value.userInfoForm.country,
                county: '',
                addressTypeCode: 'WORK',
                id: this.lcaForm.value.userInfoForm.id,
                postalCode: this.lcaForm.value.userInfoForm.postalCode,
                stateProvinceCode: this.lcaForm.value.userInfoForm.state,
            }
        };
        // employerPointOfContactInfo mapping
        this.employerPointOfContactInfo = {
            address: {
                addressLine1: this.lcaForm.value.employerContactInfoForm.addressLine1,
                addressLine2: this.lcaForm.value.employerContactInfoForm.addressLine2,
                city: this.lcaForm.value.employerContactInfoForm.city,
                countryCode: this.lcaForm.value.employerContactInfoForm.country,
                county: this.lcaForm.value.employerContactInfoForm.country,
                id: this.lcaForm.value.employerContactInfoForm.id !== 'null' ? this.lcaForm.value.employerContactInfoForm.id : null,
                postalCode: this.lcaForm.value.employerContactInfoForm.postalCode,
                addressTypeCode: 'WORK',
                stateProvinceCode: this.lcaForm.value.employerContactInfoForm.state,
                stateProvinceName: this.lcaForm.value.employerContactInfoForm.stateProvinceName,
            },
            firstName: this.lcaForm.value.employerContactInfoForm.firstName,
            jobTitle: this.lcaForm.value.employerContactInfoForm.jobTitle,
            lastName: this.lcaForm.value.employerContactInfoForm.lastName,
            middleName: this.lcaForm.value.employerContactInfoForm.middleName,
            personType: 'EMPRPOC',
            companyId: this.lcaForm.value.employerContactInfoForm.companyId !== 'null' ? this.lcaForm.value.employerContactInfoForm.companyId : null,
            employeeId: this.lcaForm.value.employerContactInfoForm.employeeId !== 'null' ? this.lcaForm.value.employerContactInfoForm.employeeId : null,
            phoneNumber: this.lcaForm.value.employerContactInfoForm.phoneNumber,
            extension: this.lcaForm.value.employerContactInfoForm.extension,
            emailId: this.lcaForm.value.employerContactInfoForm.emailId,
        };
        // attorneyOrAgentInfo mapping
        this.attorneyOrAgentInfo = {
            address: {
                addressLine1: this.lcaForm.value.attorneyInfoForm.addressLine1,
                addressLine2: this.lcaForm.value.attorneyInfoForm.addressLine2,
                city: this.lcaForm.value.attorneyInfoForm.city,
                countryCode: this.lcaForm.value.attorneyInfoForm.country,
                addressTypeCode: 'WORK',
                county: this.lcaForm.value.attorneyInfoForm.countryCode,
                id: this.lcaForm.value.attorneyInfoForm.id !== 'null' ? this.lcaForm.value.attorneyInfoForm.id : null,
                postalCode: this.lcaForm.value.attorneyInfoForm.postalCode,
                stateProvinceCode: this.lcaForm.value.attorneyInfoForm.state,
                stateProvinceName: this.lcaForm.value.attorneyInfoForm.stateProvinceName,
            },
            attorneyNameOfHighestStartCourt: this.lcaForm.value.attorneyInfoForm.attorneyNameOfHighestStartCourt,
            attorneyStateBarNo: this.lcaForm.value.attorneyInfoForm.attorneyStateBarNo,
            attorneyStateOfHighestCourt: this.lcaForm.value.attorneyInfoForm.attorneyStateOfHighestCourt,
            companyId: parseInt(this.lcaForm.value.attorneyInfoForm.firmName),
            emailId: this.lcaForm.value.attorneyInfoForm.emailId,
            employeeId: parseInt(this.lcaForm.value.attorneyInfoForm.attorneyName),
            firmFEIN: this.lcaForm.value.attorneyInfoForm.firmFEIN,
            firmName: this.lcaForm.value.attorneyInfoForm.LawFirmName,
            firstName: this.lcaForm.value.attorneyInfoForm.agentFirstName,
            lastName: this.lcaForm.value.attorneyInfoForm.agentLastName,
            middleName: this.lcaForm.value.attorneyInfoForm.agentMiddleName,
            personType: 'ATTRNAGNT',
            phoneNumber: this.lcaForm.value.attorneyInfoForm.telephone,
            extension: this.lcaForm.value.attorneyInfoForm.extension,
        };

        this.lcaAdlEmplStatH1BOnly = {
            isEmprH1bDependent: this.lcaForm.value.lcaAdlEmplStatH1BOnly.isEmprH1bDependent,
            isEmprWillfulViolator: this.lcaForm.value.lcaAdlEmplStatH1BOnly.isEmprWillfulViolator,
            isEmprForExmptH1bWrkr: this.lcaForm.value.lcaAdlEmplStatH1BOnly.isEmprForExmptH1bWrkr,
            isApndxInclWrkrExmptOnHiDegr: this.lcaForm.value.lcaAdlEmplStatH1BOnly.isApndxInclWrkrExmptOnHiDegr,
            statBasisForExmptId: this.lcaForm.value.lcaAdlEmplStatH1BOnly.statBasisForExmptId,
        };

        this.lcaPreparer = {
            firstName: this.lcaForm.value.lcaPreparer.firstName,
            middleName: this.lcaForm.value.lcaPreparer.middleName,
            lastName: this.lcaForm.value.lcaPreparer.lastName,
            firmName: this.lcaForm.value.lcaPreparer.firmName,
            emailId: this.lcaForm.value.lcaPreparer.emailId,
            personType: "PREPARER",
        };

        this.noticeOfObligations = {
            companyId: this.lcaForm.value.noticeOfObligations.companyId,
            employeeId: this.lcaForm.value.noticeOfObligations.employeeId,
            firstName: this.lcaForm.value.noticeOfObligations.firstName,
            middleName: this.lcaForm.value.noticeOfObligations.middleName,
            lastName: this.lcaForm.value.noticeOfObligations.lastName,
            designatedTitle: this.lcaForm.value.noticeOfObligations.designatedTitle,
            personType: "OBLIGATOR"
        };

        this.EmpLCS = {
            cbEmp: this.lcaForm.value.EmpLCS.cbEmp
        }
        let employmentEndDate = this.lcaForm.value.lcaEFileApplication.employmentEndDate ? moment(this.lcaForm.value.lcaEFileApplication.employmentEndDate).format('YYYY-MM-DD') : null;
        let employmentStartDate = this.lcaForm.value.lcaEFileApplication.employmentStartDate ? moment(this.lcaForm.value.lcaEFileApplication.employmentStartDate).format('YYYY-MM-DD') : null;
        // final lca form value mapping
        let socVersionEfile = localStorage.getItem('socVersionEfile');
        //set LCA ID null in case of Duplicating LCA
        let lcaID = this.isDuplicateLCA ? null : this.lcaEditID;
        const lcaFinalSave: any = {
            lcaEFileApplication: {
                id: lcaID,
                visaType: this.lcaForm.value.lcaEFileApplication.visaType,
                jobTitle: this.lcaForm.value.lcaEFileApplication.jobTitle,
                socCode: this.lcaForm.value.lcaEFileApplication.socCode,
                socTitle: this.lcaForm.value.lcaEFileApplication.socTitle,
                onetSocVer: socVersionEfile,
                isFullTime: this.lcaForm.value.lcaEFileApplication.isFullTime,
                employmentEndDate: employmentEndDate ? employmentEndDate : null,
                employmentStartDate: employmentStartDate ? employmentStartDate : null,
                totalCount: this.lcaForm.value.lcaEFileApplication.totalCount,
                newEmploymentCount: this.lcaForm.value.lcaEFileApplication.newEmploymentCount,
                continueApprovedCount: this.lcaForm.value.lcaEFileApplication.continueApprovedCount,
                changeApproveCount: this.lcaForm.value.lcaEFileApplication.changeApproveCount,
                concurrentEmploymentCount: this.lcaForm.value.lcaEFileApplication.concurrentEmploymentCount,
                employerChangeCount: this.lcaForm.value.lcaEFileApplication.employerChangeCount,
                amendedPetitionCount: this.lcaForm.value.lcaEFileApplication.amendedPetitionCount,
                isEmprReprAttorney: this.lcaForm.value.attorneyInfoForm.enableAttorney,
                publicDisclInfoId: this.lcaForm.value.publicDiscloseInfo.publicDisclInfoId,
                lcaAdlEmplStatH1BOnly: this.lcaAdlEmplStatH1BOnly,
                companyId: this.employerInfo.companyId,
                placeOfEmployments: placeOfEmployments,
                comment: this.lcaForm.value.comment
            },
            attorneyOrAgentInfo: this.attorneyOrAgentInfo,
            employerInfo: this.employerInfo,
            employerPointOfContactInfo: this.employerPointOfContactInfo,
            lcaPreparer: this.lcaPreparer,
            noticeOfObligations: this.noticeOfObligations
        };
        if (this.employerInfo.naicsCode) {
            lcaFinalSave.lcaEFileApplication.companyNaicsCode = this.lcaForm.value.userInfoForm.companyNaicsCode;
            lcaFinalSave.lcaEFileApplication.companyNaicsTitle = this.lcaForm.value.userInfoForm.companyNaicsTitle.substring(this.lcaForm.value.userInfoForm.companyNaicsTitle.indexOf("--") + 2);
        }

        if (this.eFileLCa == 'filedLCA') {
            lcaFinalSave.lcaEFileApplication.lcaFiledType = 'Ext-Filed';
            lcaFinalSave.lcaFiledType = 'Ext-Filed';
        } else if (this.eFileLCa == 'certifiedLCA') {
            lcaFinalSave.lcaEFileApplication.lcaFiledType = 'Ext-Certified';
            lcaFinalSave.lcaFiledType = 'Ext-Certified';
        } else {
            lcaFinalSave.lcaEFileApplication.lcaFiledType = 'E-Filed';
            lcaFinalSave.lcaFiledType = 'E-Filed';
        }

        return lcaFinalSave;
    }

    onClose() {
        this.closebutton.nativeElement.click();
    }

    onClickPreview() {
        let previewNode = document.getElementById("previewEfile");
        previewNode.innerHTML = '';
        let previewTempNode = document.getElementById("lcaFormParent");
        if (previewTempNode) {
            let clone = previewTempNode.cloneNode(true);
            if (clone) {
                document.getElementById("previewEfile").appendChild(clone);
            }
        }
    }

    // test(){
    //   console.warn('lcaForm', this.lcaForm);
    // }

    ngOnDestroy() {
        sessionStorage.removeItem("isCertifiesId");
        localStorage.removeItem('userEfileInfo');
        sessionStorage.removeItem('originPage');
        sessionStorage.removeItem('originUrl');
        sessionStorage.removeItem('currentCmpy');
        this.formChangesSubscription?.unsubscribe();
        this.formChangeSubscription?.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }

    handleCancel() {
        if (this.originPage && this.originUrl) {
            sessionStorage.setItem('originPage', this.originPage);
            sessionStorage.setItem('originUrl', this.originUrl);
        }
        //window.location.reload();
        //this.router.navigate([`${this.originUrl}`], { relativeTo: this.route });
        this.backToOriginPage();
    }


    createlaunchTracker() {
        let companyId = sessionStorage.getItem('companyId');
        this.launchTracker = this.fb.group({
            lcaId: [this.lcaEditID, Validators.required],
            password: ['', Validators.required],
            userName: ['', Validators.required],
            companyId: companyId
        });

    }

    onClickSavelaunchTracker() {

        if (this.launchTracker.valid) {


            // API CALL FOR SAVE API
            this.lcaService.saveUserRecoredTrackerFile(this.launchTracker.value).pipe(takeUntil(this.destroy$)).subscribe((response: any) => {

                if (response.status === 200) {
                    //this.toastr.success('', response['message']);
                    this.lcaForm.reset()
                    window.location.href = 'efile-flag://'
                    // window.location.href ='my-prot:// ';
                    this.router.navigate([`${this.originUrl}`], { relativeTo: this.route });
                }
            });
        } else {
            this.toastr.success('Flag portal user login details not saved', 'Success');

        }
    }

    launch() {
        //   this.lcaForm.reset()
        //   window.location.href ='efile-flag://'
        //  this.router.navigate([`${this.originUrl}`], { relativeTo: this.route });
        // window.location.href ='my-prot:// ';

    }

    showModalBox: boolean = false;
    public onClickPrerequisite() {


        this.showModalBox = true;
    }

    onClickDownload() {

        this.lcaService.downloadEfileTracker(this.osInstalled).pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
            if (response) {
                window.location.href = response.data.link;
                this.toastr.success(response['message'], 'Success');
                // this.router.navigate(['/lca']);

            }

        });

    }

    getUserDetails() {
        let userid = sessionStorage.getItem('userId')
        this.lcaService.getUserDetailsEfileTracker(userid).pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
            if (response) {
                this.launchTracker.patchValue({
                    password: response.data?.password,
                    userName: response.data?.userName,
                })

            }

            else {

            }

        });

    }
    copyToClipboard() {
        this.CopyToClipboard = 'Copied';
        document.addEventListener('copy', (e: ClipboardEvent) => {
            e.clipboardData.setData('text/plain', (this.lcaEditID));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
    }
    getGlobalErrorMessages(error: string) {
        return errorUtils.errorMessages.get(error);
    }

    saveAsDraft(event) {
        if (event) {
            this.onClickSaveLcaForm(event);
        }
    }

    onFilesDataChange(data: FormData) {
        this.ocrLCAUploadedFilesData = data;
    }

    convertUpload() {
        this.lcaService.convertUploadDocument(
            'OCRLCA', parseInt(sessionStorage.getItem('companyId')), this.ocrLCAUploadedFilesData)
            .subscribe(response => {
                if (response.status === 200) {
                    let responseData = (response?.data) ? JSON.parse(response.data) : {};
                    this.extractedLCADetails = responseData?.data || {};
                    this.toastr.success(response.message, 'Success');
                }
            })
    }

}